import Decimal from "decimal.js";

export const summaryNumber = (value: unknown): number | null => {
	if (typeof value !== "number" && typeof value !== "string" || typeof value === "string" && !value.trim()) return null;
	const number = Number(value);
	return Number.isFinite(number) ? number : null;
};

export const formatSummaryNumber = (value: number | null, language: string, money = false) => value === null ? "—" : value.toLocaleString(language, {
	minimumFractionDigits: money ? 2 : 0,
	maximumFractionDigits: money ? 2 : 20,
});

export const summaryBreakdown = (data: unknown) => {
	const values = Array.isArray(data) ? data.map(value => {
		const number = summaryNumber(value);
		return number !== null && number >= 0 ? number : null;
	}) : [];
	const sum = values.length > 0 && values.every(value => value !== null)
		? values.reduce<Decimal>((total, value) => total.plus(value!), new Decimal(0)).toNumber() : null;
	const total = sum !== null && Number.isFinite(sum) ? sum : null;
	return { values, total, percentages: values.map(value => value !== null && total !== null && total > 0 ? value / total * 100 : null) };
};
